module.exports = __webpack_public_path__ + "static/media/mail.3e6e6e8e.svg";